import { type AssetData, AssetImageFormat, AssetMode } from "../mediaLibrary/asset.interface";
import { defAssetQuality, getFileNameWithoutExtension, getImgUrl } from "../mediaLibrary/assetUtils";
import { type CommonSettings, type DimensionsInterface } from "../rest.interface";

export function getMarginClasses(settings: DimensionsInterface = null): string[] {
	let classes = [];
	classes = classes.concat(responsiveHelper(settings.marginTop, 'mt-', true));
	classes = classes.concat(responsiveHelper(settings.marginBottom, 'mb-', true));
	classes = classes.concat(responsiveHelper(settings.marginLeft, 'ml-', true));
	classes = classes.concat(responsiveHelper(settings.marginRight, 'mr-', true));
	return classes;
}

export function getPaddingClasses(settings: DimensionsInterface = null): string[] {
	let classes = [];
	classes = classes.concat(responsiveHelper(settings.paddingTop, 'pt-', true));
	classes = classes.concat(responsiveHelper(settings.paddingBottom, 'pb-', true));
	classes = classes.concat(responsiveHelper(settings.paddingLeft, 'pl-', true));
	classes = classes.concat(responsiveHelper(settings.paddingRight, 'pr-', true));
	return classes;

}

function getBackgroundImageUrl(asset: AssetData, settings: CommonSettings = null): string {
	let width = settings?.backgroundImageWidth;
	if (!width) {
		width = 0;
	}

	let height = settings?.backgroundImageHeight;
	if (!height) {
		height = 0;
	}

	let	type = settings.backgroundImageCrop ? AssetMode.Thumb : AssetMode.Full;

	let filename = asset?.filename;
	if (settings.backgroundImageFormat !== null) {
		filename = getFileNameWithoutExtension(filename);
		filename += '.' + settings.backgroundImageFormat;
	}

	return getImgUrl(type, asset?.id, filename, width, height, settings?.backgroundImageQuality);
}

export function getBgColorClass(settings: CommonSettings = null): string[] {
	let classes = [];

	if (settings?.backgroundClass) {
		classes.push(settings.backgroundClass)
	} else if (settings?.backgroundColor) {
		classes.push('bg-[' + settings.backgroundColor + ']');
	}

	return classes;
}

export function getBgImageClass(settings: CommonSettings = null): string[] {
	let classes = [];

	if (settings?.backgroundImageId) {
		if (settings?.backgroundSize) {
			classes.push(settings.backgroundSize);
		}
		if (settings?.backgroundRepeat) {
			classes.push(settings.backgroundRepeat);
		}
		if (settings?.backgroundPosition) {
			classes.push(settings.backgroundPosition);
		}
	}

	// @ts-ignore
	if (settings?.backgroundImage) {
		// @ts-ignore
		const imageSrc = getBackgroundImageUrl(settings.backgroundImage, settings);
		// @ts-ignore
		let imageSrcWebp = getBackgroundImageUrl(settings.backgroundImage, {
			...settings,
			backgroundImageFormat: AssetImageFormat.Webp,
			backgroundImageQuality: settings?.backgroundImageQuality ? settings.backgroundImageQuality : defAssetQuality
		});
		let imageSrcAvif = getBackgroundImageUrl(settings.backgroundImage, {...settings, backgroundImageFormat: AssetImageFormat.Avif});

		const supports = "[@supports(background:image-set('f.webp'_type('image/webp')))]";

		classes.push("bg-[url(" + imageSrc + ")]");
		//classes.push(supports + ":bg-[image-set('" + imageSrcWebp + "'_type('image/webp'))]");
		//classes.push(supports + ":bg-[image-set('" + imageSrcAvif + "'_type('image/avif'),'" + imageSrcWebp + "'_type('image/webp'))]");
	}

	return classes;
}

export function responsiveHelper(responsive: object = null, prefix = '', numeric = false): string[] {
	let c = [];

	if (responsive) {
		Object.keys(responsive).forEach((breakpoint) => {
			let value = responsive[breakpoint];

			if (value) {
				value = value.toString();

				// console.log(breakpoint, this[breakpoint]);
				if (breakpoint === 'all') {
					breakpoint = '';
				} else {
					breakpoint = breakpoint + ':';
				}

				if (value !== '' && value !== null) {
					if (numeric) {
						if (value.startsWith('rem') || value.endsWith('px')) {
							c.push(breakpoint + prefix + '[' + value + ']');
						} else {
							value = parseInt(value);
							if (value >= 0) {
								c.push(breakpoint + prefix + value);
							} else {
								c.push(breakpoint + '-' + prefix + Math.abs(value));
							}
						}
					} else {
						c.push(breakpoint + prefix + value);
					}
				}
			}
		}, responsive);
	}

	// console.log(c);
	return c;
}

export function uniqueArray(array = []): string[] {
	return [...new Set(array)];
}
